import axios from 'axios'
import resolveRequest from '../../utils/resolveRequest.js'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'

export default async (siteId, formData) => {
  const endpoint = `${apiEndpoints.sites}/${siteId}/map/upload`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.post(URL, formData, { withCredentials: true }))
}
